export const essentialData = [
  {
    id: 1,
    img: require("../../../image/Margintrade/es-img-one.webp"),
    title: "Trading Dashboard",
    content:
      "A well-organized trading dashboard is essential for users. It should offer real-time charts, detailed trade history, and an overview of open positions, profits, and losses. Users should also be able to easily monitor their available margin and leverage settings.",
  },
  {
    id: 2,
    img: require("../../../image/Margintrade/es-img-two.webp"),
    title: "User Registration and Authentication",
    content:
      "Your platform should have an easy registration process with secure authentication mechanisms like two-factor authentication (2FA). This will ensure that only verified traders can access margin trading features.",
  },
  {
    id: 3,
    img: require("../../../image/Margintrade/es-img-three.webp"),
    title: "Margin and Leverage Options",
    content:
      "Offer a wide range of leverage options such as 2x, 5x, 10x, and even higher depending on the trader's experience level. Different assets might come with different leverage limits, so clear communication of these limits is essential.",
  },
  {
    id: 4,
    img: require("../../../image/Margintrade/es-img-four.webp"),
    title: "Risk Management Tools",
    content:
      "Risk management is crucial in margin trading. Implement tools like stop-loss orders, take-profit orders, and margin alerts. These features allow traders to manage their risks by automatically closing trades when certain conditions are met, helping them prevent larger losses.",
  },
  {
    id: 5,
    img: require("../../../image/Margintrade/es-img-five.webp"),
    title: "Funding and Withdrawal Options",
    content:
      "Ensure that your platform supports a wide variety of cryptocurrencies and fiat currencies for deposits and withdrawals. This flexibility allows users to engage with the platform without having to worry about conversion issues.",
  },
  {
    id: 6,
    img: require("../../../image/Margintrade/es-img-five.webp"),
    title: "Liquidity",
    content:
      "A key factor for any successful exchange is liquidity. Ensure that your platform provides deep liquidity by connecting with various liquidity providers or aggregating liquidity from multiple sources. This ensures that trades can be executed quickly and without slippage.",
  },
  {
    id: 7,
    img: require("../../../image/Margintrade/es-img-five.webp"),
    title: "Advanced Order Types",
    content:
      "Offer various order types such as limit orders, market orders, and stop orders. These order types give traders flexibility in executing trades, whether they are looking to enter or exit positions quickly.",
  },
  {
    id: 8,
    img: require("../../../image/Margintrade/es-img-five.webp"),
    title: "Margin Calculator",
    content:
      "A margin calculator helps traders understand the total amount they can borrow based on their deposit, as well as the potential profit or loss. This tool is essential for traders looking to calculate their position sizes effectively.",
  },
];
